import * as React from 'react';
import { Grid, Button, Alert, ProgressBar, Fieldset } from '../../common';
import ReadOnlyField from '../../common/form-controls/ReadOnly';
import UserLookup from '../../common/form-controls/Lookups/UserLookup';
import { useEffect, useState } from 'react';
import UserLookupObject from '../../../models/UserLookupObject';
import TemporaryAccessPasswordService from '../../../services/TemporaryAccessPasswordService';
import { AlertBanner } from '../../../models/interfaces/AlertBanner';
import StandardModal from '../../common/modals/StandardModal';

interface TAPModalOnBehalfOfProps {
	visible: boolean;
	setVisible: any;
	tapService: TemporaryAccessPasswordService;
	refreshTap: any;
}

const TAPModalOnBehalfOf = ({ visible, setVisible, tapService, refreshTap }: TAPModalOnBehalfOfProps) => {
	const [employee, setEmployee] = useState<UserLookupObject>();
	const [enableRequestButton, setEnableRequestButton] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isVerifyingSup, setIsVerifyingSup] = useState<boolean>(false);
	const [tap, settap] = useState<string>('');
	const [alertBanner, setAlertBanner] = useState<AlertBanner>({
		visible: false,
		variant: 'default',
	});
	const [delegated, setDelegated] = useState<boolean>(false);

	useEffect(() => {
		settap('');
		enableRequest();
	}, [employee]);

	const handleCloseAlert = () => {
		setAlertBanner({ visible: false, variant: 'default' });
	};

	const handleRequest = async () => {
		try {
			setIsLoading(true);

			var response;
			if (delegated) response = await tapService.createTapOnBehalfOfDelegated(employee.id);
			else response = await tapService.createOnBehalfOfTap(employee.id);

			if (response.taPass != null) {
				settap(response.taPass);
				setEnableRequestButton(false);
			} else {
				setAlertBanner({
					visible: true,
					text: `TAP could not be generated, please try again or submit a feedback for getting assistance`,
					variant: 'error',
				});
			}
			setIsLoading(false);
		} catch (err) {
			setIsLoading(false);
			settap('');
			setAlertBanner({
				visible: true,
				text: err.response.data.message,
				variant: 'error',
			});
			console.log(err.response.data.message);
		}
	};

	const handleClose = async () => {
		if (tap != '') {
			refreshTap(true);
		}
		setVisible(false);
	};

	//Validates if requestor is the supervisor of the selected employee
	const enableRequest = async () => {
		try {
			if (employee) {
				setIsVerifyingSup(true);
				const response = await tapService.getSupVerifycation(employee.userPrincipalName);
				setIsVerifyingSup(false);
				setEnableRequestButton(true);
				setDelegated(false);
			} else {
				setEnableRequestButton(false);
				setIsVerifyingSup(false);
			}
		} catch (err) {
			try {
				setIsVerifyingSup(true);
				const response = await tapService.getDelegatedVerifycation(employee.userPrincipalName);
				setIsVerifyingSup(false);
				setEnableRequestButton(true);
				setDelegated(true);
			} catch (err) {
				setEnableRequestButton(false);
				setIsVerifyingSup(false);
				setAlertBanner({
					visible: true,
					text: 'You are not the supervisor neither delegated for the user provided',
					variant: 'error',
				});
			}
		}
	};

	return (
		<StandardModal
			show={visible}
			onDismiss={() => setVisible(false)}
			title="TAP Request"
			footer={
				<Grid variant="2up">
					<Grid.Item>
						<Button variant="secondary" onClick={() => handleClose()} disabled={isLoading}>
							Cancel
						</Button>
					</Grid.Item>
					<Grid.Item>
						<Button
							variant="primary"
							onClick={() => handleRequest()}
							disabled={!enableRequestButton || isLoading || isVerifyingSup}
						>
							{isLoading || isVerifyingSup ? 'Loading...' : 'Request'}
						</Button>
					</Grid.Item>
				</Grid>
			}
		>
			{isLoading || isVerifyingSup ? (
				<ProgressBar
					className="em-u-margin-top-half"
					indeterminate
					label={isLoading ? 'Getting TAP' : 'Verifying Supervisor or Delegated'}
				/>
			) : (
				<>
					<UserLookup
						id="employee-lookup"
						label="On Behalf Of:"
						note={'You must be the Supervisor of the selected employee'}
						value={employee?.displayName}
						onChange={(value) => setEmployee(value)}
						//style={{padding: "0", marginBottom: "0 !important"}}
					/>
					{alertBanner.visible && (
						<Alert
							variant={alertBanner.variant}
							onClose={handleCloseAlert}
							style={{ margin: '1rem 0' }}
							body={alertBanner.text}
						/>
					)}
					<Fieldset legend="Generated Password">
						<ReadOnlyField label="Temporary Access Password" text={tap} copy={true} />
					</Fieldset>
				</>
			)}
			<Alert
				variant="warning"
				style={{ margin: '0' }}
				body="Please keep track of this passcode. The passcode is valid for 60 minutes and you cannot generate another passcode until the current passcode expires."
			/>
		</StandardModal>
	);
};

export default TAPModalOnBehalfOf;
